// Version checker utility for automatic page reload when version changes

export const APP_VERSION = "4.1"; // Update this when you change the version

export const checkVersionAndReload = () => {
  const STORAGE_KEY = 'infogig_app_version';
  const storedVersion = localStorage.getItem(STORAGE_KEY);
  
  console.log(`Version check: stored=${storedVersion}, current=${APP_VERSION}`);
  
  if (storedVersion && storedVersion !== APP_VERSION) {
    console.log(`Version changed from ${storedVersion} to ${APP_VERSION}. Reloading page...`);
    
    // Clear cache and reload
    if ('caches' in window) {
      caches.keys().then(function(names) {
        for (let name of names) {
          caches.delete(name);
        }
      });
    }
    
    // Clear localStorage for this version check
    localStorage.setItem(STORAGE_KEY, APP_VERSION);
    
    // Force reload with cache bypass
    window.location.reload(true);
    return true;
  } else if (!storedVersion) {
    // First time visit, just store the version
    localStorage.setItem(STORAGE_KEY, APP_VERSION);
  }
  
  return false;
};

export const getStoredVersion = () => {
  return localStorage.getItem('infogig_app_version');
};

export const getCurrentVersion = () => {
  return APP_VERSION;
};
